import * as S from "./style";
//Components
import ActionButtonResponsy from "../../Button/ActionButtonResponsy";
import InputSearch from "../../FieldSearch";
import CreateAcessory from "../../Modals/Accessory/Create";
import CreateCancell from "../../Modals/Cancellation/Create";
import CreateCard from "../../Modals/Card/Create";
import CreateOS from "../../Modals/OS/Create";
import CreateService from "../../Modals/Service/Create";
import Create from "../../Modals/Supplier/Create";
import CreateUser from "../../Modals/User/Create";
import Toast from "../../Toast";
//Hooks
import { useState } from "react";
import { useMultipleModal } from "../../../hooks/useMultipleModal";
//icons
import { Plus } from "@phosphor-icons/react";

interface ITitle {
  title: string;
  subtitle: string;
  placeholderSearch: string;
  fetchData: () => void;
  filterSearch: (search: string) => void;
  modalKey: string;
  titleButton: string;
  visibleButton?: boolean;
}

export default function TitleDefault({
  title,
  subtitle,
  placeholderSearch,
  fetchData,
  titleButton,
  modalKey,
  filterSearch,
  visibleButton = true
}: ITitle) {

  const { isOpenModal, toggleModalVisibility } = useMultipleModal();
  const [toastData, setToastData] = useState({
    status: 200,
    message: "",
  });

  const handleInputChange = (inputSearch: string) => {
    filterSearch(inputSearch);
  };

  return (
    <S.Container>
      <S.Title>
        <S.H4>{title}</S.H4>
        <S.H6>{subtitle}</S.H6>
      </S.Title>

      <S.ContentSearch>
        <InputSearch name={placeholderSearch} onSearch={handleInputChange} />
        {
          visibleButton &&
          <ActionButtonResponsy
            name={titleButton}
            Icon={<Plus size={20} />}
            onClick={() => toggleModalVisibility(modalKey)}
          />
        }
      </S.ContentSearch>

      <Create
        isOpenModal={isOpenModal("supplier")}
        setModalClose={() => toggleModalVisibility("supplier")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateUser
        isOpenModal={isOpenModal("user")}
        setModalClose={() => toggleModalVisibility("user")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateAcessory
        isOpenModal={isOpenModal("accessory")}
        setModalClose={() => toggleModalVisibility("accessory")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateService
        isOpenModal={isOpenModal("service")}
        setModalClose={() => toggleModalVisibility("service")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateOS
        isOpenModal={isOpenModal("service-order")}
        setModalClose={() => toggleModalVisibility("service-order")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateCancell
        isOpenModal={isOpenModal("cancellation")}
        setModalClose={() => toggleModalVisibility("cancellation")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateCard
        isOpenModal={isOpenModal("card")}
        setModalClose={() => toggleModalVisibility("card")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <Toast
        openToast={isOpenModal('open-toast')}
        closeToast={() => toggleModalVisibility('open-toast')}
        message={toastData.message}
        status={toastData.status}
      />
    </S.Container>
  );
}
